import React from 'react';
import { buildApiUrl } from '../config/api';

  const FileTable = ({
  uploadedFiles,
  styles,
  formatDate,
  getCategoryName,
  getTypeName,
  truncateWords,
  setShowDescription,
  confirmDelete,
  setStatusModalFile,
  setNewStatusId,
  totalPages,
  currentPage,
  handleApplyFilters,
  sortConfig,
  onSort,
  isRefreshing,
  isLoadingPage,
  isTableLoading,
  isBulkMode,
  selectedFileIds,
  onToggleSelectFile,
  onSelectAllCurrentPage,
  isBulkUpdating,
  onMarkViewed,
  isCA,
  isAdmin
}) => {
  const safeSelectedIds = Array.isArray(selectedFileIds) ? selectedFileIds : [];
  const markViewed = typeof onMarkViewed === 'function' ? onMarkViewed : () => {};

  const ViewedIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="#8B8EF2" strokeWidth="2" fill="none" />
      <path d="M8 12.5l2.5 2.5 5-5" stroke="#8B8EF2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  const UnreadIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4 13.2c2.5-3.2 5.5-4.9 8-4.9s5.5 1.7 8 4.9"
        stroke="#8B8EF2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="13.4" r="2.4" fill="#8B8EF2" />
    </svg>
  );
  const renderSortableHeader = (label, key) => {
    const isActive = sortConfig?.field === key;
    const indicator = isActive ? (sortConfig.direction === 'asc' ? '▲' : '▼') : '▲▼';

    return (
      <th
        style={{ ...styles.th, cursor: 'pointer', textAlign: 'center' }}
        onClick={() => onSort(key)}
        title="Sort"
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', textTransform: 'uppercase', letterSpacing: '0.02em' }}>
          <span>{label}</span>
          <span style={{ fontSize: '0.85em', opacity: isActive ? 1 : 0.6 }}>{indicator}</span>
        </div>
      </th>
    );
  };

  const toDisplayUpper = (value) => {
    const normalized = value === null || value === undefined ? '' : String(value).trim();
    return normalized ? normalized.toUpperCase() : '';
  };

  const currentPageIds = uploadedFiles.map(file => file.FileID);
  const allSelectedOnPage = isBulkMode && currentPageIds.length > 0 && currentPageIds.every(id => safeSelectedIds.includes(id));

  if (isTableLoading) {
    return (
      <div style={styles.noRecordsContainer}>
        <div style={styles.noRecordsMessage}>Loading records...</div>
      </div>
    );
  }

  if (uploadedFiles.length === 0) {
    return (
      <div style={styles.noRecordsContainer}>
        <div style={styles.noRecordsMessage}>No records found</div>
      </div>
    );
  }

  return (
    <div
      style={{
        ...styles.recordsContainer,
        opacity: isRefreshing || isLoadingPage ? 0.3 : 1,
        transition: 'opacity 0.10s ease'
      }}
    >
      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              {isBulkMode && (
                <th style={{ ...styles.th, textAlign: 'center' }}>
                  <label style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', cursor: 'pointer', userSelect: 'none', color: 'inherit' }}>
                    <input
                      type="checkbox"
                      checked={allSelectedOnPage}
                      onChange={onSelectAllCurrentPage}
                      disabled={isBulkUpdating}
                      aria-label="Select all on current page"
                      style={{ transform: 'scale(1.05)' }}
                    />
                    <span style={{ fontSize: '12px', fontWeight: 600, color: 'inherit', letterSpacing: '0.02em' }}>(Select all)</span>
                  </label>
                </th>
              )}
              {renderSortableHeader('File ID', 'fileId')}
              {renderSortableHeader('Date', 'date')}
              {renderSortableHeader('User', 'user')}
              {renderSortableHeader('Category', 'category')}
              {renderSortableHeader('Type', 'type')}
               <th style={{ ...styles.th, textAlign: 'center', textTransform: 'uppercase' }}>Description</th>
              {renderSortableHeader('County', 'county')}
              {renderSortableHeader('Status', 'status')}
              <th style={{ ...styles.th, textAlign: 'center', textTransform: 'uppercase' }}>View</th>
              <th style={{ ...styles.th, textAlign: 'center', textTransform: 'uppercase' }}>Delete</th>
            </tr>
          </thead>
          <tbody>
            {uploadedFiles.map((file, index) => (
              <tr key={index}>
                {isBulkMode && (
                  <td style={{ ...styles.td, textAlign: 'center' }}>
                    <input
                      type="checkbox"
                      checked={safeSelectedIds.includes(file.FileID)}
                      onChange={() => onToggleSelectFile(file.FileID)}
                      disabled={isBulkUpdating}
                      aria-label={`Select file ${file.FileID}`}
                    />
                  </td>
                )}
                <td style={{ ...styles.td, textAlign: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                    <span style={isAdmin && Boolean(file.IsAdminOnly) ? { color: '#e11d48', fontWeight: 700 } : {}}>{file.FileID}</span>
                    {isAdmin && Boolean(file.IsAdminOnly) && (
                      <em style={{ color: '#e11d48', fontSize: 16, fontStyle: 'italic', fontWeight: 700 }}>Int</em>
                    )}
                  </div>
                </td>
                <td style={styles.td}>{formatDate(file.UploadDate)}</td>
                <td style={styles.td}>{file.UploadedBy || '—'}</td>
                <td style={styles.td}>{getCategoryName(file.AttachmentCategoryID)}</td>
                <td style={styles.td}>{getTypeName(file.AttachmentTypeID)}</td>
                <td style={styles.td}>
                  {truncateWords(toDisplayUpper(file.Description), 5)}
                  {file.Description && file.Description.trim().split(/\s+/).length > 5 && (
                    <span
                      onClick={() => setShowDescription(file)}
                      style={styles.showMoreLink}
                    >
                      Show more
                    </span>
                  )}
                </td>
                <td style={styles.td}>{file.County || '—'}</td>
                <td style={styles.td}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span>{file.Status || '—'}</span>
                    <button
                      onClick={() => {
                        setStatusModalFile(file);
                        setNewStatusId(file.StatusID);
                      }}
                      style={{ ...styles.editStatusIcon, display: 'inline-flex', alignItems: 'center', gap: '6px', background: 'transparent', border: 'none', padding: 0 }}
                      title="Edit Status"
                      aria-label="Edit status"
                    >
                      <span aria-hidden="true">&#x1F589;</span>
                    </button>
                  </div>
                </td>
                <td style={styles.td}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                    <a
                      href={buildApiUrl(`files/uploads/${file.FileID}/download`)}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={styles.viewButton}
                      onClick={() => {
                        if (isCA && file.HasViewFlag) {
                          markViewed(file.FileID);
                        }
                      }}
                    >
                      View
                    </a>
                    {isCA && file.HasViewFlag && (
                      <span
                        title={file.IsViewedByUser ? 'Viewed' : 'Not viewed yet'}
                        aria-label={file.IsViewedByUser ? 'Viewed' : 'Not viewed yet'}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: 26,
                          height: 22
                        }}
                      >
                        {file.IsViewedByUser ? <UnreadIcon /> : <ViewedIcon />}
                      </span>
                    )}
                  </div>
                </td>
                <td style={styles.td}>
                  <button
                    onClick={() => confirmDelete(file.FileID)}
                    style={styles.deleteButton}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {totalPages > 1 && (
          <div style={styles.paginationWrapper}>
            <ul style={styles.pagination}>
              <li>
                <button
                  style={styles.pageButton}
                  onClick={() => handleApplyFilters(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </button>
              </li>

              {Array.from({ length: totalPages }).map((_, index) => {
                const page = index + 1;
                if (
                  page === 1 ||
                  page === totalPages ||
                  Math.abs(page - currentPage) <= 1
                ) {
                  return (
                    <li key={page}>
                      <button
                        style={{
                          ...styles.pageButton,
                          ...(currentPage === page ? styles.activePage : {})
                        }}
                        onClick={() => handleApplyFilters(page)}
                      >
                        {page}
                      </button>
                    </li>
                  );
                } else if (
                  (page === currentPage - 2 && page > 1) ||
                  (page === currentPage + 2 && page < totalPages)
                ) {
                  return (
                    <li key={page}>
                      <span style={styles.ellipsis}>…</span>
                    </li>
                  );
                }
                return null;
              })}

              <li>
                <button
                  style={styles.pageButton}
                  onClick={() => handleApplyFilters(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  &gt;
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default FileTable;
